import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CourierProfileService } from '../../shared/services/courier-profile.service';
import { CourierOptionDefinition } from '../../../models/courier-option-definition';
import { UntypedFormGroup, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { selectShipmentEditorMetric, selectShipmentEditorOptions } from '../../../store/shipment-editor/shipment-editor.state';
import { InteractionEnum } from '../../../enum/interaction.enum';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';
import { shipmentEditorPatchOptions } from '../../../store/shipment-editor/shipment-editor.actions';

@Component({
    selector: 'app-courier-option-editor',
    templateUrl: './courier-option-editor.component.html',
    styleUrls: ['./courier-option-editor.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSuffix, MatSelect, MatOption, AsyncPipe]
})
export class CourierOptionEditorComponent implements OnInit, OnDestroy {

    @Input()
    option: {
        code: string;
        caption: string;
        description: string;
        type: string;
        default: string;
        choices: [ { code: string; caption: string } ];
        parameters: any[];
        requirePackaging: any[];
        excludePackaging: any[];
        requireInternational: boolean
    };

    metric$: Observable<boolean>;
    formGroup: FormGroup;
    formSubscription: Subscription;
    stateSubscription: Subscription;

    constructor(private store: Store<AppState>) {
    }

    ngOnInit(): void {
        this.metric$ = this.store.select(selectShipmentEditorMetric);
        this.formGroup = new FormGroup({});
        this.formGroup.addControl(this.option.code, new FormControl('1'));
        this.option.parameters.forEach((p) => {
            this.formGroup.addControl(p.code, new FormControl(''));
        });
        this.formSubscription = this.formGroup.valueChanges.subscribe(value => {
            this.store.dispatch(shipmentEditorPatchOptions({ options: value }));
        });
        this.stateSubscription = this.store.select(selectShipmentEditorOptions).subscribe(options => {
            this.formGroup.patchValue(options, { emitEvent: false });
        });
    }

    ngOnDestroy(): void {
        if (this.formSubscription) {
            this.formSubscription.unsubscribe();
            this.formSubscription = null;
        }
        if (this.stateSubscription) {
            this.stateSubscription.unsubscribe();
            this.stateSubscription = null;
        }
    }

    userChange(): void {
    }

}
